'use client';
import styled from 'styled-components';
import Link from 'next/link';

export const Wrapper = styled.div`
  background: ${props => props.theme.colors.background.base};
  width: 100%;
`;

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;

  @media ${props => props.theme.tabletL} {
    flex-direction: row;
  }
`;

export const DesktopImageContainer = styled.div`
  display: none;

  @media ${props => props.theme.tabletL} {
    display: flex;
    position: relative;
    width: 50%;
    overflow: hidden;

    img {
      width: 100%;
      height: 100% !important;
      object-fit: cover;
    }
  }
`;

export const MobileImageContainer = styled.div`
  overflow: hidden;
  border-radius: 24px;
  width: 100%;
  aspect-ratio: 16 / 11;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media ${props => props.theme.tabletL} {
    display: none;
  }
`;

export const FormContainer = styled.div`
  padding: ${props => props.theme.spacing(5)};
  align-items: center;
  color: ${props => props.theme.colors.text.secondary};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  gap: ${props => props.theme.spacing(5)};

  @media ${props => props.theme.tabletL} {
    margin: auto;
    width: 50%;
    max-width: 500px;
    padding: ${props => props.theme.spacing(8, 8, 12)};
    justify-content: center;
    gap: ${props => props.theme.spacing(6)};
  }
`;

export const Heading = styled.h3`
  ${({ theme }) => theme.typography.heading2};
  color: ${props => props.theme.colors.text.primary};
  margin: 0;
  text-align: center;

  @media ${props => props.theme.tablet} {
    ${({ theme }) => theme.typography.heading3};
  }
`;

export const Subheading = styled.p`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.primary};
  text-align: center;
  margin: 0;

  @media ${props => props.theme.tabletL} {
    width: 90%;
  }
`;

export const MultipetBanner = styled.div`
  width: 100%;
  padding: ${props => props.theme.spacing(2, 3)};
  margin: ${props => props.theme.spacing(-2, 0)};
  background-color: ${props => props.theme.colors.neutral.light};
  border-radius: ${props => props.theme.spacing(2)};
  color: ${props => props.theme.colors.text.primary};
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
`;

export const HeadlineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing(4)};
  width: 100%;
`;

export const ButtonStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing(5)};
  width: 100%;
`;

export const SecondaryButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(2)};
`;

export const SecondaryAction = styled.button`
  background: none;
  border: none;
  padding: ${props => props.theme.spacing(1, 2)};
  font: inherit;
  color: ${props => props.theme.colors.hero.plum};
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const LogoLink = styled(Link)`
  border: 2px solid transparent;
  &:focus,
  &:active {
    border: 2px solid transparent;
  }
`;
